import React from 'react'

const CompletedProjects = () => {
  return (
    <div>CompletedProjects</div>
  )
}

export default CompletedProjects